import getDistance from 'geolib/es/getDistance';

import type { Store } from '@adapters/prismic/fetching/stores/types';
import type { StoreWithDistance } from '@context/StoresContext';

/** Max distance in meters (50KM) from the selected favourite store for PDP preview (other stores in this radius). */
export const PDP_PREVIEW_MAX_DISTANCE_M = 50_000;

function distanceFromFavouriteMeters(
  store: StoreWithDistance,
  favouriteStore: Store
): number | undefined {
  const favouriteGeo = favouriteStore.data.geo;
  const storeGeo = store.data.geo;
  if (!favouriteGeo || !storeGeo) {
    return undefined;
  }

  const { latitude: lat1, longitude: lon1 } = favouriteGeo;
  const { latitude: lat2, longitude: lon2 } = storeGeo;
  if (
    ![lat1, lon1, lat2, lon2].every(
      (n) => typeof n === 'number' && !Number.isNaN(n)
    )
  ) {
    return undefined;
  }
  return getDistance(
    { latitude: lat1, longitude: lon1 },
    { latitude: lat2, longitude: lon2 }
  );
}

/**
 * Preview list: stores within {@link PDP_PREVIEW_MAX_DISTANCE_M} of the favourite store’s coordinates.
 * Uses store geo only (not {@link StoreWithDistance.distanceInMeters} or device location)
 * so the radius always matches the selected store.
 */
export function filterStoresForPdpPreview(
  stores: StoreWithDistance[] | undefined,
  favouriteStore: Store | undefined
): StoreWithDistance[] {
  if (!stores?.length || !favouriteStore) {
    return [];
  }

  return stores.filter((s) => {
    const meters = distanceFromFavouriteMeters(s, favouriteStore);
    return meters != null && meters <= PDP_PREVIEW_MAX_DISTANCE_M;
  });
}
